import React, { useEffect, useState } from 'react'
import "../../assets/style/eegisterProvider.css"
import TextField from '@mui/material/TextField';
import { Button, FormControl, InputLabel, MenuItem, Select } from '@mui/material';
import components from '../../components';
import { Link,Outlet,useNavigate, useLocation, useParams } from 'react-router-dom';
import ApiCall from '../../utils/Api';
import { toast } from 'react-toastify';
const Sales3 = () => {
     const navigate = useNavigate();
     const location = useLocation();
     const {id}=useParams()
     const [transetionDetails, settransetionDetails] = useState([])
     const [date, setdate] = useState("All")
     const [name, setName] = useState("");
     const goBack = () => {
      navigate(-1);
    };
     useEffect(() => {
       const getPurchasedDataUnit = async () => {
         try {
          
           const data = await ApiCall.SECURE_API.get(`/admin/getDataUnitRecords/${id}?period=${date}`)
           // console.log("🚀 ~ getPurchasedDataUnit ~ data:", data.data.data.buyer.purchasedDataUnits)
           console.log("🚀 ~ getPurchasedDataUnit ~ data:", data.data.data)
           setName(data.data.providerName)
           settransetionDetails(data.data.data)
         } catch (error) {
           if (error?.response?.data?.message) {
             toast.error(error.response.data.message);
           } else {
             toast.error(error.message);
           }
           console.log("🚀 ~ getPurchasedDataUnit ~ error:", error)
   
         }
   
       }
       getPurchasedDataUnit()
     }, [date])
  return (
     <div style={{width:"100%",backgroundColor:"#F3F4F8"}}>
     <span className='RegisterProviderText'>
   <div style={{display:"flex",justifyContent:"space-between"}}>
   <span style={{paddingLeft:20}}>
   <Button variant="contained"  onClick={goBack} style={{ marginRight: "20px",backgroundColor:"black" }}>
         {"< Back"}
        </Button>
    Data & Sales Transactions - Detail:<span style={{color:"gray"}}>{name}</span></span> 
   <div style={{ display: "flex", flexDirection: "row", width: "10%",  justifyContent: "space-between", alignItems: "center" }}>
                                   <FormControl style={{ width: "90%" }} >
                                        <InputLabel id="demo-simple-select-label">Date</InputLabel>
                                        <Select
                                             labelId="demo-simple-select-label"
                                             id="demo-simple-select"
                                             name='SDL'
                                             value={date}
                                             label="Date"
                                             // onChange={(e) => setinstrument(e.target.value)}
                                             onChange={(e)=>{
                                                  console.log("🚀 ~ e:")
                                                  setdate(e.target.value)
                                             }
                                             }
                                        >
                                              <MenuItem  value="1D">1D</MenuItem>
                                              <MenuItem  value="1W">1W</MenuItem>
                                              <MenuItem  value="1M">1M</MenuItem>
                                              <MenuItem  value="1Y">1Y</MenuItem>
                                              <MenuItem  value="1YD">1YD</MenuItem>
                                              <MenuItem  value="2Y">2Y</MenuItem>
                                              <MenuItem  value="5Y">5Y</MenuItem>
                                              <MenuItem value="All">All</MenuItem>
                                        </Select>
                                   </FormControl>
                                  
                              </div >
    </div>     
     </span>
            <div style={{display:"flex",flexDirection:"column",alignItems:"center",justifyContent:"space-around",width:"100%"}}>
                           
                            <div style={{width:"98%",marginTop:40}}>
                                <components.Table.SalesTable3 transetionDetails={transetionDetails} filterState={date}/>    
                            </div>  
                            
            </div>
         
</div>
  )
}

export default Sales3